import { Button } from '@/components/ui/button'
import clsx from 'clsx'
import { ShoppingCart } from 'lucide-react'
import { useTranslations } from 'next-intl'
import React from 'react'

export function OpenCartButton({
  className,
  quantity,
  ...rest
}: {
  className?: string
  quantity?: number
}) {
  const t = useTranslations('navigation')
  return (
    <button
      aria-label={t('cart')}
      className={clsx(
        // HDR-3: h-11 w-11 (44px) tap target per WCAG 2.5.5 / Apple HIG. Icon
        // stays 16–20px visually; only the clickable container grows.
        // Uniform header icon-button: foreground icon → jade on hover, hover fill.
        "h-11 w-11 flex items-center justify-center rounded-full transition-all hover:bg-foreground/10 hover:scale-110 duration-200 group relative flex-shrink-0",
        className
      )}
      {...rest}
    >
      <ShoppingCart className="h-4 w-4 sm:h-5 sm:w-5 text-foreground group-hover:text-jade transition-colors" aria-hidden="true" />

      {quantity ? (
        <span className="absolute -top-1 -right-1 bg-jade text-white text-micro font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center shadow-sm" aria-hidden="true">
          {quantity}
        </span>
      ) : null}
    </button>
  )
}
